import Color from '@/Enums/Color.enum';
import GeoType, { GEO_TYPE_LABELS } from '@/Enums/Geography/GeographyType.enum';
import { Box, SxProps, Theme } from '@mui/material';
import { memo, useMemo } from 'react';

const scaleColor: Record<GeoType, Color> = {
  [GeoType.Zip]: Color.Purple,
  [GeoType.Dma]: Color.RedOrange,
  [GeoType.State]: Color.AccentYellow,
  [GeoType.County]: Color.AccentGreen,
  [GeoType.CongressionalDistrict]: Color.LightBlue,
  [GeoType.City]: Color.BrightPink,
  [GeoType.Country]: Color.Purple,
};

interface IProps {
  className?: string;
  locationType: GeoType;
  sx?: SxProps<Theme>;
}

const LocationTypeLabel = memo(({ className, sx, locationType }: IProps) => {
  const color = useMemo(() => scaleColor[locationType], [locationType]);

  return (
    <Box
      sx={{ padding: '0 12px', borderRadius: '12px', borderWidth: '1px', borderColor: color, color, ...sx }}
      className={className}
    >
      {GEO_TYPE_LABELS[locationType]}
    </Box>
  );
});

export default LocationTypeLabel;
